const craftsman_task = {
	name: 'Handwerkerauftrag | Handwerkeraufträge',
	icon: 'fas fa-hammer',
	fields: {
		hp_id: 'ID',
		building: {
			name: '@:entity.building.name',
		},
		first_unit: {
			position: '@:entity.unit.fields.position',
		},
		to_occur: '@:common.toOccur',
		craftsman_person: '@:component.craftsmanTasks.craftsman',
		subject_type: 'Art',
		subject: '@:common.subject',
		status: {
			name: 'Status',
		},
	},
	revisionFields: {
		subject_type: 'Art',
		subject: '@:common.subject',
		craftsman_person: '@:component.craftsmanTasks.craftsman',
		status: '@:common.status',
		team: 'Sachbearbeiter',
		type: 'Auftragsart',
		process: '@:component.craftsmanTasks.process',
		to_occur: '@:common.toOccur',
		deadline: '@:common.deadline',
		finished: 'Erledigt am',
		estimated_price: '@:component.craftsmanTasks.estimated_price',
		bill_price: 'Rechnungsbetrag',
		hp: 'ID',
		synced_at: 'Synchronisiert am',
		// AAR-1812/1813: Labels fuer die *_removed-Loeschmarker aus
		// CraftsmanTaskAssociationRevisionObserver (hartgeloeschte Verknuepfungen,
		// die als Aenderungszeile auf dem HWA selbst landen).
		person_removed: 'Person entfernt',
		contact_removed: 'Ansprechpartner entfernt',
		document_removed: 'Dokument entfernt',
		building_removed: 'Liegenschaft entfernt',
		unit_removed: 'Einheit entfernt',
		record_removed: 'Akte entfernt',
		cis_removed: 'Z.I.S. Notiz entfernt',
		task_removed: 'Wiedervorlage entfernt',
	},
}

export default craftsman_task
